import http from './http';

export default {
  all(groupId) {
    return http().get(`/v1/shareable_groups/${groupId}/emails`);
  },
  create(groupId, data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/shareable_groups/${groupId}/emails`, data);
  },
  delete(id) {
    return http().delete(`/v1/shareable_group_emails/${id}`);
  },
}
